import {
  aboutHeader,
  aboutHeaderDetailsWrapper,
  HorizontalFlexContainer,
  messageForConnectionType,
  SiteUrlsContext,
} from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { TableQuery_tables, TableQuery_tables_DatabaseTable_database } from '../../../gen-src/queries/TableQuery';
import {
  AboutHeaderDescriptionDetailItem,
  renderAboutHeaderDatabaseNameLinkItem,
  renderAboutHeaderTagsDetailList,
  renderAboutHeaderTextDetailItem,
  renderEmbeddedAssetDescription,
  renderFileType
} from '../AboutHeaderDetailItems';

export type TableDetailsProps = {
  readonly table: TableQuery_tables;
};

function renderDatabaseType(database: TableQuery_tables_DatabaseTable_database) {
  return database.connectionType ?
    renderAboutHeaderTextDetailItem(
      Messages.ConnectionType(), messageForConnectionType(database.connectionType), 'table-details-database-type-test-id'
    )
    : null;
}

function renderDetails(table: TableQuery_tables, urls: SiteUrls) {
  if (table.__typename === 'DatabaseTable' && table.database) {
    const element: (JSX.Element | null)[] = [];
    switch (table.database.__typename) {
      case 'File':
        if (table.database.name) {
          element.push(
            renderAboutHeaderDatabaseNameLinkItem(Messages.FileName(),
              table.database.name,
              table.database.id,
              'table-details-filename-test-id',
              urls));
        }
        if (table.database.filePath) {
          element.push(renderAboutHeaderTextDetailItem(Messages.FilePath(), table.database.filePath, 'table-details-filepath-test-id'));
        }
        if (table.database.connectionType) {
          element.push(renderFileType(table.database.connectionType));
        }
        break;
      case 'CloudFile':
        if (table.database.name) {
          element.push(renderAboutHeaderDatabaseNameLinkItem(Messages.FileName(),
            table.database.name,
            table.database.id,
            'table-details-cloudfile-name-test-id',
            urls));
        }
        if (table.database.connectionType) {
          element.push(renderAboutHeaderTextDetailItem(Messages.ConnectionType(), messageForConnectionType(table.database.connectionType),
            'table-details-connection-type-test-id'));
        }
        break;
      case 'WebDataConnector':
        if (table.database.connectorUrl) {
          element.push(renderAboutHeaderTextDetailItem(Messages.WebDataConnectorUrl(), table.database.connectorUrl,
            'table-details-web-data-connector-url-test-id'));
        }
        element.push(renderAboutHeaderTextDetailItem(Messages.ConnectionType(), Messages.WebDataConnector(),
          'table-details-wdc-connection-type-test-id'));
        break;
      case 'DatabaseServer':
        if (table.database.name) {
          element.push(renderAboutHeaderDatabaseNameLinkItem(Messages.DatabaseName(),
            table.database.name,
            table.database.id,
            'table-details-database-name-test-id',
            urls));
        }
        element.push(renderDatabaseType(table.database));
        if (table.database.hostName) {
          element.push(renderAboutHeaderTextDetailItem(Messages.Hostname(), table.database.hostName, 'table-details-hostname-test-id'));
        }
        if (table.fullName) {
          element.push(renderAboutHeaderTextDetailItem(Messages.FullName(), table.fullName, 'table-details-fullname-test-id'));
        }
        break;
      default:
        element.push(renderDatabaseType(table.database));
    }
    if (table.isEmbedded) {
      element.push(renderEmbeddedAssetDescription('table-asset-details-category-test-id'));
    }
    return element;
  }
  return null;
}

export function TableDetails(props: TableDetailsProps): JSX.Element {
  return (
    <SiteUrlsContext.Consumer>
      {urls =>
        <div data-tb-test-id={'table-details-wrapper-test-id'} className={aboutHeaderDetailsWrapper}>
          <div className={aboutHeader}>{Messages.About()}</div>
          <div>
            <HorizontalFlexContainer fillFlexParent={true}>
              {renderDetails(props.table, urls)}
            </HorizontalFlexContainer>
            {props.table.__typename === 'DatabaseTable' && 'tags' in props.table ?
              renderAboutHeaderTagsDetailList(props.table.tags, 'table-details-tags-test-id',
                urls, props.table.__typename) : null}
            <AboutHeaderDescriptionDetailItem description={props.table.description || ''} testId={'table-details-description-test-id'} />
          </div>
        </div>
      }
    </SiteUrlsContext.Consumer>
  );
}
